import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header align-items-center border-0 mt-4\"><h3 class=\"card-title align-items-start flex-column\"><span class=\"fw-bolder mb-2 text-dark\">Progres</span><span class=\"text-muted fw-bold fs-7\"> Manajemen Progres </span></h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-color-primary btn-active-light-primary\" data-kt-menu-trigger=\"click\" data-kt-menu-placement=\"bottom-end\" data-kt-menu-flip=\"top-end\"></button></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-5" }
const _hoisted_4 = { class: "timeline-label" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">1</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-warning fs-1\"></i></div><div class=\"timeline-content d-flex\"><div class=\"row\"><div class=\"col\"><span class=\"fw-bolder text-gray-800 ps-3\">Webinar</span></div></div></div></div>", 1)
const _hoisted_6 = { class: "timeline-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_8 = { class: "col ml-3" }
const _hoisted_9 = { class: "timeline-content d-flex" }
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Pengisi Webinar "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Respon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Peserta"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_20 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">2</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-info fs-1\"></i></div><div class=\"timeline-content fw-bolder text-gray-800 ps-3\"> Presentasi </div></div>", 1)
const _hoisted_24 = { class: "timeline-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_26 = { class: "col ml-3" }
const _hoisted_27 = { class: "timeline-content d-flex" }
const _hoisted_28 = { class: "card-body py-3" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Pengisi Presentasi "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Respon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Peserta"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_37 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_38 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">3</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-success fs-1\"></i></div><div class=\"timeline-content fw-bolder text-gray-800 ps-3\"> Proposal </div></div>", 1)
const _hoisted_42 = { class: "timeline-item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_44 = { class: "col ml-3" }
const _hoisted_45 = { class: "timeline-content d-flex" }
const _hoisted_46 = { class: "card-body py-3" }
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">4</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-danger fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Follow Up</span></div></div>", 1)
const _hoisted_55 = { class: "timeline-item" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_57 = { class: "col ml-3" }
const _hoisted_58 = { class: "timeline-content d-flex" }
const _hoisted_59 = { class: "card-body py-3" }
const _hoisted_60 = { class: "table-responsive" }
const _hoisted_61 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">5</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-warning fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">PKS</span></div></div>", 1)
const _hoisted_68 = { class: "timeline-item" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_70 = { class: "col ml-3" }
const _hoisted_71 = { class: "timeline-content d-flex" }
const _hoisted_72 = { class: "card-body py-3" }
const _hoisted_73 = { class: "table-responsive" }
const _hoisted_74 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">6</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-warning fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Pengumpulan Data</span></div></div>", 1)
const _hoisted_81 = { class: "timeline-item" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_83 = { class: "col ml-3" }
const _hoisted_84 = { class: "timeline-content d-flex" }
const _hoisted_85 = { class: "card-body py-3" }
const _hoisted_86 = { class: "table-responsive" }
const _hoisted_87 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "File Input"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Kreator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Processed"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = { class: "text-center" }
const _hoisted_91 = { class: "text-center" }
const _hoisted_92 = { class: "text-center" }
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = { class: "text-center" }
const _hoisted_95 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">7</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-primary fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Pre Implementasi</span></div></div>", 1)
const _hoisted_96 = { class: "timeline-item" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_98 = { class: "col ml-3" }
const _hoisted_99 = { class: "timeline-content d-flex" }
const _hoisted_100 = { class: "card-body py-3" }
const _hoisted_101 = { class: "table-responsive" }
const _hoisted_102 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_104 = { class: "text-center" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = { class: "text-center" }
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">8</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-success fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Tagihan</span></div></div>", 1)
const _hoisted_109 = { class: "timeline-item" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_111 = { class: "col ml-3" }
const _hoisted_112 = { class: "timeline-content d-flex" }
const _hoisted_113 = { class: "card-body py-3" }
const _hoisted_114 = { class: "table-responsive" }
const _hoisted_115 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_117 = { class: "text-center" }
const _hoisted_118 = { class: "text-center" }
const _hoisted_119 = { class: "text-center" }
const _hoisted_120 = { class: "text-center" }
const _hoisted_121 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">9</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-danger fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Implementasi</span></div></div>", 1)
const _hoisted_122 = { class: "timeline-item" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_124 = { class: "col ml-3" }
const _hoisted_125 = { class: "timeline-content d-flex" }
const _hoisted_126 = { class: "card-body py-3" }
const _hoisted_127 = { class: "table-responsive" }
const _hoisted_128 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_130 = { class: "text-center" }
const _hoisted_131 = { class: "text-center" }
const _hoisted_132 = { class: "text-center" }
const _hoisted_133 = { class: "text-center" }
const _hoisted_134 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">10</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-info fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">After Sales</span></div></div>", 1)
const _hoisted_135 = { class: "timeline-item" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_137 = { class: "col ml-3" }
const _hoisted_138 = { class: "timeline-content d-flex" }
const _hoisted_139 = { class: "card-body py-3" }
const _hoisted_140 = { class: "table-responsive" }
const _hoisted_141 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Penanggung Jawab "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note")
  ])
], -1)
const _hoisted_143 = { class: "text-center" }
const _hoisted_144 = { class: "text-center" }
const _hoisted_145 = { class: "text-center" }
const _hoisted_146 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.widgetClasses])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("table", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataWebinar, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(item.progressDate), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(item.actorName), 1),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(item.processed == true ? "Sudah" : "Belum"), 1),
                            _createElementVNode("td", _hoisted_17, [
                              (item.respon == 'Cold')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Cold "))
                                : _createCommentVNode("", true),
                              (item.respon == 'Warm')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Warm "))
                                : _createCommentVNode("", true),
                              (item.respon == 'Hot')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Hot "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(item.participant), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(item.note), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("table", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataPresentasi, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_32, _toDisplayString(item.progressDate), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(item.actorName), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(item.processed == true ? "Sudah" : "Belum"), 1),
                            _createElementVNode("td", _hoisted_35, [
                              (item.respon == 'Cold')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Cold "))
                                : _createCommentVNode("", true),
                              (item.respon == 'Warm')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Warm "))
                                : _createCommentVNode("", true),
                              (item.respon == 'Hot')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Hot "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(item.participant), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(item.note), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("table", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataProposal, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_50, _toDisplayString(item.progressDate), 1),
                            _createElementVNode("td", _hoisted_51, _toDisplayString(item.actorName), 1),
                            _createElementVNode("td", _hoisted_52, _toDisplayString(item.processed == true ? "Sudah" : "Belum"), 1),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(item.note), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("table", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataFollowUp, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_63, _toDisplayString(item.progressDate), 1),
                            _createElementVNode("td", _hoisted_64, _toDisplayString(item.actorName), 1),
                            _createElementVNode("td", _hoisted_65, _toDisplayString(item.contractStatus), 1),
                            _createElementVNode("td", _hoisted_66, _toDisplayString(item.note), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("table", _hoisted_74, [
                      _hoisted_75,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.tampilPKS.progressDate), 1),
                          _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.tampilPKS.actorName), 1),
                          _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.tampilPKS.contractStatus), 1),
                          _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.tampilPKS.note), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("table", _hoisted_87, [
                      _hoisted_88,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataCollect, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_89, _toDisplayString(item.progressDate), 1),
                            _createElementVNode("td", _hoisted_90, _toDisplayString(item.fileName), 1),
                            _createElementVNode("td", _hoisted_91, _toDisplayString(item.creatorName), 1),
                            _createElementVNode("td", _hoisted_92, _toDisplayString(item.actorName), 1),
                            _createElementVNode("td", _hoisted_93, _toDisplayString(item.processed == true ? "Sudah" : "Belum"), 1),
                            _createElementVNode("td", _hoisted_94, _toDisplayString(item.note), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_95,
          _createElementVNode("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("table", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.tampilPreImplementasi.progressDate), 1),
                          _createElementVNode("td", _hoisted_105, _toDisplayString(_ctx.tampilPreImplementasi.actorName), 1),
                          _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.tampilPreImplementasi.processed == true
                              ? "Sudah"
                              : "Belum"), 1),
                          _createElementVNode("td", _hoisted_107, _toDisplayString(_ctx.tampilPreImplementasi.note), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_108,
          _createElementVNode("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("table", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.tampilTagihan.progressDate), 1),
                          _createElementVNode("td", _hoisted_118, _toDisplayString(_ctx.tampilTagihan.actorName), 1),
                          _createElementVNode("td", _hoisted_119, _toDisplayString(_ctx.tampilTagihan.processed == true ? "Sudah" : "Belum"), 1),
                          _createElementVNode("td", _hoisted_120, _toDisplayString(_ctx.tampilTagihan.note), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_121,
          _createElementVNode("div", _hoisted_122, [
            _hoisted_123,
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("table", _hoisted_128, [
                      _hoisted_129,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_130, _toDisplayString(_ctx.tampilImplementasi.progressDate), 1),
                          _createElementVNode("td", _hoisted_131, _toDisplayString(_ctx.tampilImplementasi.actorName), 1),
                          _createElementVNode("td", _hoisted_132, _toDisplayString(_ctx.tampilImplementasi.processed == true
                              ? "Sudah"
                              : "Belum"), 1),
                          _createElementVNode("td", _hoisted_133, _toDisplayString(_ctx.tampilImplementasi.note), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_134,
          _createElementVNode("div", _hoisted_135, [
            _hoisted_136,
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("table", _hoisted_141, [
                      _hoisted_142,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.tampilAfterSales.progressDate), 1),
                          _createElementVNode("td", _hoisted_144, _toDisplayString(_ctx.tampilAfterSales.actorName), 1),
                          _createElementVNode("td", _hoisted_145, _toDisplayString(_ctx.tampilAfterSales.processed == true
                              ? "Sudah"
                              : "Belum"), 1),
                          _createElementVNode("td", _hoisted_146, _toDisplayString(_ctx.tampilAfterSales.note), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}